// Get time from options at or before value.  Assumes sorted options.

export function snapInterpolation(
    times: Array<number>,
    selectedTime: number,
): number
{
    if ( times.length < 2 ) return 0;

    if ( selectedTime <= times[0] ) return times[0];
    if ( selectedTime >= times[times.length - 1] ) return times[times.length - 1];

    for ( let i = 0; i < times.length - 1; i++ )
    {
        const t0 = times[i];
        const t1 = times[i + 1];

        if ( t0 <= selectedTime && selectedTime <= t1 )
        {
            const delta = t1 - t0;
            const preWeight = ( t1 - selectedTime ) / delta;
            return preWeight > 0.5 ? t0 : t1;
        }
    }

    if ( process.env.NODE_ENV === "production" )
    {
        console.error( "snapInterpolation should never reach here" );
    }
    return 0; //should not reach here
}

export function isMobileWidth( width: number )
{
    return width <= 800;
}

export function assertUnreachable(): never
{
    throw new Error( "did not expect code to reach here" );
}

export async function timeout( ms: number ): Promise<void>
{
    return new Promise( ( resolve ) => setTimeout( resolve, ms ) );
}
